import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { ChangeEvent } from 'react';
interface IControlledCheckboxGroup {
  options: any[];
  onChange?: (value: string[]) => void;
  value?: string[];
  hasError: boolean;
  dataTestIdSuffix: string;
}
export default function ControlledCheckboxGroup({
  options,
  onChange,
  value,
  hasError,
  dataTestIdSuffix
}: Readonly<IControlledCheckboxGroup>) {
  const selectedValues = Array.isArray(value) ? value : [];
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange?.([...selectedValues, event.target.name]);
    } else {
      onChange?.(selectedValues.filter(item => item !== event.target.name));
    }
  };
  const {
    t
  } = useTranslation('needsBasedQuestions');
  return <Box sx={{
    display: 'flex',
    mb: 2
  }} data-sentry-element="Box" data-sentry-component="ControlledCheckboxGroup" data-sentry-source-file="ControlledCheckboxGroup.tsx">
			<FormControl component="fieldset" variant="standard" required error={hasError} aria-labelledby={dataTestIdSuffix} data-sentry-element="FormControl" data-sentry-source-file="ControlledCheckboxGroup.tsx">
				<FormGroup data-sentry-element="FormGroup" data-sentry-source-file="ControlledCheckboxGroup.tsx">
					{options.map(option => {
          return <FormControlLabel key={option.value} control={<Checkbox color="secondary" checked={selectedValues.includes(option.value)} onChange={handleChange} name={option.value} />} label={<Typography variant="bodyMediumBook" color="text.secondary">
										{option.label}
									</Typography>} />;
        })}
				</FormGroup>
				{hasError && selectedValues.length === 0 ? <FormHelperText>
						<Typography variant="errorValidation">{t('required')}</Typography>
					</FormHelperText> : null}
			</FormControl>
		</Box>;
}